import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import { useEffect } from "react";
import { FaRegCircle, FaCircle } from "react-icons/fa6";
import Helpers from "@/Helpers";


export default function Beauties(props) {
    const { sectionData, values, setValue } = props;
    const currentSection = sectionData?.currentSection;
    const content: Record<string, string> = Helpers.getSectionContent(currentSection, sectionData?.lang);
    const elements = Helpers.getSectionElements(content);
    const contentItems = Array.isArray(elements?.items) ? elements.items : [];
    const contentOptions = Array.isArray(elements?.options) ? elements.options : [];
    const instructionsHtml = Helpers.getSectionHtmlValue(content, "instructions");
    const reminderHtml = Helpers.getSectionHtmlValue(content, "reminder");

    function getIssueCountForPage(validationValues, page) {
        if (!Array.isArray(contentItems)) return 0;

        const currentPageItems = contentItems.filter((item) => Number(item?.page) === Number(page));
        return currentPageItems.filter((item) => {
            const fieldValue = validationValues?.[currentSection.formId + item.id];
            return fieldValue === undefined || fieldValue === null || fieldValue === "";
        }).length;
    }

    useEffect(() => {
        sectionData.registerSection( 600);
    }, [currentSection?.name]);

    useEffect(() => {
        const nextCount = Number(sectionData?.nextCount || 0);
        const page = Number(sectionData?.page || 1);
        const issueCount = nextCount > 0 ? getIssueCountForPage(values || {}, page) : 0;
        sectionData?.updateIssueCount?.(issueCount);
    }, [contentItems, currentSection?.formId, sectionData?.nextCount, sectionData?.page, sectionData?.updateIssueCount, values]);

    if (!sectionData) return;
    const pageItems = contentItems.filter((item) => Number(item?.page) === Number(sectionData?.page || 1));
    const options = contentOptions.filter((option) => option && option.label !== undefined);

    useEffect(() => {
        if (!sectionData?.isAdmin) return;

        const handleKeyDown = (e: KeyboardEvent) => {
            const activeTag = document.activeElement?.tagName?.toLowerCase();
            if (activeTag === "input" || activeTag === "textarea" || activeTag === "select") return;

            const key = (e.key || "").toLowerCase();
            if (key !== "t" && key !== "f") return;

            const selectableOptions = contentOptions.filter((option) => option && option.label !== undefined);

            const targetOption = selectableOptions.find((option) => {
                const label = String(option?.label || "").trim().toLowerCase();
                return key === "t" ? label.startsWith("t") : label.startsWith("f");
            });

            if (!targetOption) return;

            const nextUnanswered = pageItems.find((item) => {
                const fieldValue = values?.[currentSection.formId + item.id];
                return fieldValue === undefined || fieldValue === null || fieldValue === "";
            });

            if (!nextUnanswered) return;

            e.preventDefault();
            onSelectValue(nextUnanswered.id, targetOption?.value ?? (selectableOptions.indexOf(targetOption) + 1));
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [sectionData?.isAdmin, contentOptions, pageItems, values, currentSection?.formId]);

    function getItemValue(itemId) {
        return values?.[currentSection.formId + itemId];
    }

    function hasAnswer(itemId) {
        const itemValue = getItemValue(itemId);
        return !(itemValue === undefined || itemValue === null || itemValue === "");
    }

    function onSelectValue(itemId, selectedValue) {
        setValue(itemId, selectedValue);
    }

    return (
        <div className="beauties page" >

            <div className="instructions left">
                {parseSanitizedHtml((Number(sectionData?.page || 1) === 1 ? instructionsHtml : reminderHtml) || "")}
            </div>

            <div className="beautiesList no-select">
                {options.length > 0 && (
                    <table className="tableData beautiesTable no-select">
                        <thead>
                            <tr className="beautiesHeader">
                                <th className="questionCol" />
                                {options.map((option, index) => (
                                    <th className="optionHeader" key={`header-${index}`}>
                                        {option?.label || ""}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {pageItems.map((item) => {
                                const itemValue = getItemValue(item.id);
                                const itemText = item.text || item.description || item.name || "";

                                return (
                                    <tr key={item.id} className={`beautiesRow${sectionData?.showValidations && !hasAnswer(item.id) ? " invalid" : ""}`}>
                                        <td className="questionText">{item.id}. {itemText}</td>

                                        {options.map((option, index) => {
                                            const optionValue = option?.value ?? (index + 1);
                                            const optionLabel = option?.label || "";
                                            const checked = String(itemValue) === String(optionValue);

                                            return (
                                                <td
                                                    key={`${item.id}-${optionValue}`}
                                                    className={`answerCell${checked ? " checked" : ""}`}
                                                    onClick={() => onSelectValue(item.id, optionValue)}
                                                    title={optionLabel}
                                                >
                                                    {checked
                                                        ? <FaCircle className="actionIcon" />
                                                        : <FaRegCircle className="actionIcon" />}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}

                {options.length === 0 && (
                    <div className="beautiesMissingOptions">No options configured.</div>
                )}
            </div>
        </div>
    );
}


